export default {
  salaryVerification() {
    return {
      data: {
        Result: 'Success',
        'File Name': '123-2345-2322235-232324(IncomeStatement).jpeg',
      },
    };
  },
  identityVerification(payload, progressCallback) {
    progressCallback(100);
    return {
      data: {
        'app-id': '442095c6-3847-e811-80f4-00155d2cc6b8',
        'id-side': payload['id-side'],
        result: 'Success',
        'file-name': '442095c6-3847-e811-80f4-00155d2cc6b8--20190627164407297(Passport & Residence Visa).png',
        'parsed-id': {
          Lines: 'ILARE0932574392784198615383183<br />8601089M2202196IND<<<<<<<<<<<9<br />SYED<KHASIM<<SYED<KHADAR<BASHA',
          DocType: 'IL',
          Country: 'ARE',
          Surname: 'SYED KHASIM',
          Givename: 'SYED KHADAR BASHA',
          DocNumber: '093257439',
          CheckNumber: '2',
          Nationality: 'IND',
          Birth: '860108',
          BirthCheckNumber: '9',
          Sex: 'M',
          ExpirationDate: '220219',
          ExpirationCheckNumber: '6',
          PersonalNumber: '78419861538318',
          PersonalNumberCheck: '3',
          SecondRowCheckNumber: '9',
        },
      },
    };
  },
};
